import { combineReducers } from '@reduxjs/toolkit';

import { Action as RootAction } from '@occc-app/rootRedux/action';

import { default as types, State } from './types';

import { reducer as audiences } from '../components/Audiences';
import { reducer as constraints } from '../components/Constraints';
import { reducer as earningMechanisms } from '../components/EarningMechanisms';
import { reducer as limits } from '../components/Limits';
import { reducer as marketingContent } from '../components/MarketingContent';
import { reducer as metaData } from '../components/Summary';
import { reducer as getStarted } from '../components/GetStarted';

const initialState: State['submission'] = {
  errorMessages: [],
  fireRedirect: false,
  offerId: '',
  requesting: true,
  submitting: false,
};

function submission(state: State['submission'] = initialState, action: RootAction) {
  switch (action.type) {
    case types.CLEAR_OFFER_COMPONENT_STATE:
      return initialState;
    case types.REQUEST_OFFER:
      return {
        ...state,
        offerId: action.offerId,
      };
    case types.REQUEST_OFFER_OK:
      return {
        ...state,
        requesting: false,
      };
  }
  return state;
}

export default combineReducers<State>({
  audiences,
  constraints,
  earningMechanisms,
  limits,
  marketingContent,
  metaData,
  getStarted,
  submission,
});
